import { FaHome } from "react-icons/fa";
import { BsTools } from "react-icons/bs";
import { PiLeafLight } from "react-icons/pi";

export const NavigationItems = [
  {
    mainPageName: "Home",
    icon: <FaHome />,

    route: "/",
    dropDownPages: [{ page: "sub1" }, { page: "sub2" }, { page: "sub3" }],
  },
  {
    mainPageName: "About",
    icon: <PiLeafLight />,

    route: "/about",
    dropDownPages: [{ page: "sub1" }, { page: "sub2" }, { page: "sub3" }],
  }
];
